import Vue from "vue";
import Vuex from "vuex";
import api from "../axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    showNavBar: false,
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_SHOW_NAVBAR(state, status) {
      state.showNavBar = status;
    },
  },
  actions: {
    async SET_USER(state) {
      try {
        const response = await api.get("/user");
        const success = response.data.success;
        if (success) {
          state.commit("SET_USER", response.data.user);
        } else {
          state.commit("SET_USER", {});
        }
      } catch (err) {
        // 401 = not authenticated — this is normal for guests, just clear user
        state.commit("SET_USER", {});
        // Only show error toast for actual server errors (5xx, network, etc.)
        if (err.response && err.response.status === 401) {
          // Silent — expected when not logged in
        } else {
          Vue.notify({
            group: "alert",
            type: "error",
            title: "Something went wrong",
          });
        }
      }
    },
    SET_SHOW_NAVBAR(state, showNavBar) {
      state.commit("SET_SHOW_NAVBAR", showNavBar);
    },
  },
  modules: {},
  getters: {
    GET_USER: (state) => state.user,
    SHOW_NAV_BAR: (state) => state.showNavBar,
  },
});
